export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Редактировать магазин"])}
}